// Admin API client — /admin/promo-codes/* (mirrors the API's promo-codes aggregate).

import type { AdminPromoCoupon } from '@a7y/types';
import { client } from './transport';

export const promoCodesApi = {
  // Promo Codes
  getPromoCoupons: () => client.get<{ data: AdminPromoCoupon[] }>('/promo-codes/coupons'),
  createPromoCoupon: (data: {
    name: string;
    type: 'percent_off' | 'extended_trial';
    percentOff?: number;
    trialDays?: number;
    duration: 'once' | 'repeating' | 'forever';
    durationInMonths?: number;
    maxRedemptions?: number;
    redeemBy?: string;
  }) => client.post<{ message: string; coupon: AdminPromoCoupon }>('/promo-codes/coupons', data),
  deletePromoCoupon: (couponId: string) =>
    client.delete<{ message: string }>(`/promo-codes/coupons/${couponId}`),
  createPromoCode: (
    couponId: string,
    data: {
      code: string;
      maxRedemptions?: number;
      expiresAt?: string;
      firstTimeTransaction?: boolean;
    }
  ) => client.post<{ message: string }>(`/promo-codes/coupons/${couponId}/codes`, data),
  deletePromoCode: (couponId: string, codeId: string) =>
    client.delete<{ message: string }>(`/promo-codes/coupons/${couponId}/codes/${codeId}`),
};
